import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ActionResultModel } from 'src/app/models/common/ActionResultModel';
import { DocumentoTipoRequisito, EstadoSolicitud, eTipoCreacion, eTypeResult, SolicitudSeccion } from 'src/app/models/common/enumModel';
import { FilterConfiguracionDocumentoModel } from 'src/app/models/configuracion-documento/FilterConfiguracionDocumentoModel';
import { ContratistaModel } from 'src/app/models/contratista/ContratistaModel';
import { IFilterConfiguracionDocumentoModel } from 'src/app/models/interfaces/configuracion-documento/IFilterConfiguracionDocumentoModel';
import { ISolicitudModel } from 'src/app/models/interfaces/ISolicitudModel';
import { IFilterTipoVisitaModel } from 'src/app/models/interfaces/tipo-visita/IFilterTipoVisitaModel';
import { DocumentacionRequeridaModel } from 'src/app/models/solicitud/DocumentacionRequeridaModel';
import { SolicitudDocumentoTecnicoModel } from 'src/app/models/solicitud/SolicitudDocumentoTecnicoModel';
import { SolicitudModel } from 'src/app/models/solicitud/SolicitudModel';
import { FilterTipoVisitaModel } from 'src/app/models/tipo-visita/FilterTipoVisitaModel';
import { TipoVisitaModel } from 'src/app/models/tipo-visita/TipoVisitaModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { ConfiguracionDocumentoService } from 'src/app/services/configuracion-documento/configuracion-documento.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { ContratistaService } from 'src/app/services/contratista/contratista.service';
import { ParametroService } from 'src/app/services/parametros/parametro.service';
import { SolicitudService } from 'src/app/services/solicitud/solicitud.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import { TipoVisitaService } from 'src/app/services/tipo-visita/tipo-visita.service';

@Component({
  templateUrl: './solicitud-contratista-registrar.component.html',
  styleUrls: ['./solicitud-contratista-registrar.component.css']
})
export class SolicitudContratistaRegistrarComponent implements OnInit {
  public model!: ISolicitudModel;

  constructor(
    public dialog: MatDialog,
    private service: SolicitudService,
    public storageService: StorageService,
    private contratistaService: ContratistaService,
    private dialogService: ConfirmDialogService,
    private alertDialogService: AlertDialogService,
    private configuracionDocumentoService: ConfiguracionDocumentoService,
    private router: Router,
    private tipoVisitaService: TipoVisitaService
  ) { 
    this.model = new SolicitudModel();
    this.model.idTipoCreacion = eTipoCreacion.CONTRATISTA;
  }

  ngOnInit(): void {
    let usuario = this.storageService.getCurrentUser();
    this.contratistaService.getById(usuario.idContratista).subscribe((data: ContratistaModel) => {
      this.model.idContratista = data.idContratista;
      this.model.contratista = data.nombre;
    });
    const filterTipoVisita: IFilterTipoVisitaModel = new FilterTipoVisitaModel();
      this.tipoVisitaService.getList(filterTipoVisita).subscribe((data: TipoVisitaModel[]) => {
        data.forEach(element => {
          if(element.defaulContratista){
            this.model.idTipoVisita = element.idTipoVisita;
            this.model.tipoVisita = element.nombre;
            this.getConfiguracionDocumentosPorTipoVisita();
          }
        });
      });
  }

  save() {
    this.model.idEstado = EstadoSolicitud.SOLICITADO;
  }

  getConfiguracionDocumentosPorTipoVisita() {
    const filterConfiguracionDocumentos: IFilterConfiguracionDocumentoModel =
      new FilterConfiguracionDocumentoModel();
    
    filterConfiguracionDocumentos.idTipoVisita = this.model.idTipoVisita;
      
    this.configuracionDocumentoService
      .getList(filterConfiguracionDocumentos)
      .subscribe((data: DocumentacionRequeridaModel[]) => {
        // console.log(data);
        data.forEach((p) => {
          p.esRequisitoBloqueado =
            p.idRequisito === DocumentoTipoRequisito.TODOS;
        });

        this.model.lista_documentos_personal = data.filter(
          (p) => p.seccion == SolicitudSeccion.Personal && p.esPredeterminado
        );
        this.model.lista_documentos_equipos = data.filter(
          (p) => p.seccion == SolicitudSeccion.Equipos && p.esPredeterminado
        );
        this.model.lista_documentos_vehiculos = data.filter(
          (p) => p.seccion == SolicitudSeccion.Vehiculos && p.esPredeterminado
        );

        this.model.documentosTecnicos = data
          .filter(
            (p) =>
              p.seccion == SolicitudSeccion.DocumentacionTecnica &&
              p.esPredeterminado
          )
          .map((item) => {
            let documento = new SolicitudDocumentoTecnicoModel();
            documento.idConfiguracionDocumento = item.idConfiguracionDocumento;
            documento.idMaestroDocumento = item.idMaestroDocumento;
            documento.documento = item.documento;
            documento.esPredeterminado = item.esPredeterminado;
            documento.idRequisito = item.idRequisito;
            // documento2.seccion = idSeccion;
            documento.controlarFechas = item.controlarFechas;
            documento.esRequisitoBloqueado =
              documento.idRequisito === DocumentoTipoRequisito.TODOS;

            return documento;
          });
      });
  }

  closed(){
    this.dialogService.open('Se perderán los cambios no guardados ¿esta seguro de salir?'); //options
          this.dialogService.confirmed().subscribe((confirmed) => {
            if (confirmed) {
              this.router.navigate(['/solicitudes-contratista']);
            }
          });
  }

  onSubmit(form: NgForm) {
    if (form.invalid) {
      if (form.controls.notificarA.status == 'INVALID') {
        this.alertDialogService.open('Error en campo Notificar A (correo).');
      } else {
        this.alertDialogService.open('Debe ingresar en campos requeridos');
      }
    } else {
      if (this.model.idSedeSelected)
        this.model.idSede = this.model.idSedeSelected;

      if (this.model.idCompaniaSelected)
        this.model.idCompania = this.model.idCompaniaSelected;
      // if (this.model.idTipoVisitaSelected)
      //   this.model.idTipoVisita = this.model.idTipoVisitaSelected;

      if (this.validar()) {
        if (
          this.model.idEstado == EstadoSolicitud.SOLICITADO &&
          this.model.lista_documentos_personal.length > 0
        ) {
          this.dialogService.open('¿Deseas guardar los cambios?'); //options
          this.dialogService.confirmed().subscribe((confirmed) => {
            if (confirmed) {              
              // this.saveData();
              this.submitForm();
            }
          });
        } else {
          this.submitForm();
        }
      }
    }
  }

  validar(): boolean {
    let errors = 0;

    if (this.model.idContratista === 0) {
      this.alertDialogService.open('Debe seleccionar un contratista');
      errors++;
    }

    if (
      this.model.idEstado == EstadoSolicitud.SOLICITADO &&
      this.model.lista_documentos_personal.length == 0
    ) {
      this.alertDialogService.open(
        'Debe registrar por lo menos un documento requerido en la seccion PERSONAL.'
      );
    }

    return errors == 0;
  }

  submitForm() {
    this.model.documentosRequeridos = [];

    this.model.lista_documentos_personal.forEach((p) => {
      this.model.documentosRequeridos.push(p);
    });
    this.model.lista_documentos_equipos.forEach((p) => {
      this.model.documentosRequeridos.push(p);
    });
    this.model.lista_documentos_vehiculos.forEach((p) => {
      this.model.documentosRequeridos.push(p);
    });
    
    if (
      (this.model.idEstado == EstadoSolicitud.SOLICITADO &&
        this.model.lista_documentos_personal.length > 0) ||
      this.model.idEstado == EstadoSolicitud.EN_ELABORACION
    ) {
      this.service.submit(this.model).subscribe((result : ActionResultModel) => {  
        if(result.type!=eTypeResult.SUCCESS){
          this.alertDialogService.open(result.message);
        }    
        else{  
          this.alertDialogService.open('Se inició la solicitud, por favor subir la información requerida en cada sección para continuar el proceso.'); //options
          this.router.navigate(['/solicitudes/', result.recordId,'completar']);
        }
      });
    }
  }

}
